/**
 * @description Running duration counter display
 *
 * Key features:
 * - Shows elapsed time since clock-in (HH:MM:SS)
 * - Updates every second
 * - Large, readable display for kiosk use
 */

import React, { useState, useEffect } from 'react';

const TimeDisplay = ({ startTime, label }) => {
  const [elapsed, setElapsed] = useState('00:00:00');

  useEffect(() => {
    if (!startTime) {
      setElapsed('00:00:00');
      return;
    }

    const update = () => {
      const start = new Date(startTime).getTime();
      const now = Date.now();
      const diff = Math.max(0, Math.floor((now - start) / 1000));

      const hours = Math.floor(diff / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = diff % 60;

      setElapsed(
        `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      );
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <div className="text-center">
      {label && <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">{label}</p>}
      <p className="text-3xl font-mono font-bold text-white">{elapsed}</p>
    </div>
  );
};

export default TimeDisplay;
